import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { X } from "react-feather";
import ReactTooltip from "react-tooltip";
import axios from "axios";
import { getApiUrl } from "../../../../utils/baseUrl";
import { toast } from "react-toastify";
import { getFavouriteDetailsHandler } from "@redux/Bookmark/bookmark.action";
import { useDispatch } from "react-redux";
import { captureException } from "@sentry/browser";
import { loadingBookmarkData } from "@redux/Bookmark/bookmarksSlice";
import { getSidebarCountData } from "../../../../redux/Sidebar/sidebarCount.action";
import { profileName, profileType } from "@utils/enum";

const intelAPIEndpoints = {
  deleteFavouriteCompany: getApiUrl("deleteFavouriteCompany"),
};

export const FavouriteDeleteModal = ({ show, handleClose, selectedCompanyArray, payload, clearSelection, setPayload, setCurrentPage, type }) => {
  const [companiesData, setCompaniesData] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedCompanyArray.length && show) {
      setCompaniesData(selectedCompanyArray);
    }
  }, [selectedCompanyArray, show]);

  const removeCompanyHandler = (index) => {
    let companiesDataClone = JSON.parse(JSON.stringify(companiesData));
    companiesDataClone.splice(index, 1);
    setCompaniesData(companiesDataClone);
  };

  const submitHandler = () => {
    axios
      .post(intelAPIEndpoints.deleteFavouriteCompany, {
        company_ids: companiesData.map((item) => item.id),
      })
      .then(() => {
        handleClose();
        dispatch(loadingBookmarkData());
        dispatch(getFavouriteDetailsHandler({ payload }));
        setPayload(payload);
        clearSelection();
        dispatch(getSidebarCountData());
        setCurrentPage(1);
        toast.success(`${companiesData.length} companies have been removed successfully`);
      })
      .catch((err) => {
        handleClose();
        captureException(err);
      });
  };

  const casingHandler = (str) => {
    let string = str;
    if (companiesData.length === 1) {
      if (type === profileType.logistics || type === profileType.company) {
        return profileType.company;
      }
      string = str.substring(0, str.length - 1);
      return string.toLowerCase();
    } else {
      return str.toLowerCase();
    }
  };

  return (
    <div>
      <Modal centered size="lg" show={show} onHide={() => handleClose()}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <div className="row">
            <div className="col-6 add_to_fav_left_con py-2">
              <p className="add_to_fav_input_heading">
                Removing {companiesData.length} {profileName[type] === profileName.logistics ? casingHandler("companies") : casingHandler(profileName[type])}
              </p>
              {!!companiesData &&
                companiesData.map((item, index) => (
                  <div key={item.key} className="d-flex add-fav-modal-comp-pill delete-side-pill  align-items-center">
                    <p data-for={"index"} data-tip={item.key ? item.key : item.company_name} className="m-0">
                      {item.key ? item.key.slice(0, 40) : item.company_name ? item.company_name.slice(0, 40) : ""}
                      {!!item.key && item.key.length > 40 ? "..." : !!item.company_name && item.company_name.length > 40 ? "..." : ""}
                    </p>
                    <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id={"index"} />
                    {companiesData.length > 1 ? <X size="16" onClick={() => removeCompanyHandler(index)} /> : ""}
                  </div>
                ))}
            </div>
            <div className="col-6 py-2">
              <p className="mb-3 add_to_fav_input_heading delete_text_heading">Please confirm if you want to remove {profileName[type] === profileName.logistics ? casingHandler("companies") : casingHandler(profileName[type])} from your Bookmarks.</p>
              <p className="mt-0 add_to_fav_input_heading delete_text_heading">To confirm, please click on the Remove button.Once confirmed, they would be permanently removed from the list.</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="fav-modal-cancel close-btn-upsell" variant="secondary" onClick={() => handleClose()}>
            Close
          </Button>
          <button className="btn btn-danger delete-btn-upsell" onClick={() => submitHandler()}>
            Remove
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
